import React from "react";
import "./How_it_works.css";
import { Link } from "react-router-dom";

const How_it_works = () => {
  return (
    <>
      <section className="How_it_works_sec">
        <div className="container">
          <div className="titlediv">
            <h3>How It Works</h3>
          </div>

          <div className="imgsec mb-5">
            <Link to="/registration">
              <img
                className="bannerimg"
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/home/how-work/lead-only.png"
                }
                alt="lead-only"
              />
            </Link>
          </div>

          <div className="imgsec">
            <Link to="/registration">
              <img
                className="bannerimg"
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/home/how-work/lead-admission.png"
                }
                alt="lead-admission"
              />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default How_it_works;
